import debug from './debug'

let store = {
  auth: {
    token: null,
    user: null
  },
  login: {
    redirect: null
  },
  player: {
    keyStored: false,
    passStored: false
  }
}

if (process && process.env && process.env.NODE_ENV === 'development') {
  debug(store, 'store')
}

export default store

export let StorePlugin = {
  install (Vue) {
    Vue.prototype.$store = store
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js